export const BLOCK_DAY = 'day';
